import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SearchRounded from '@mui/icons-material/SearchRounded';
import { CircularProgress, InputAdornment, TextField } from '@mui/material';

import { useTagCloud } from 'src/components/dashboard/DashboardContext/TagCloudContext';

import { styles } from './index.styles';

export const TAG_CLOUD_SEARCH_TEST_ID = 'tag-cloud-search';
export const TAG_CLOUD_TEXT_FILTER_SEARCH_ICON_TEST_ID =
  'tag-cloud-text-filter-search-icon';
export const TAG_CLOUD_TEXT_FILTER_LOADING_ICON_TEST_ID =
  'tag-cloud-text-filter-loading-icon';

const TagCloudSearch: FC = () => {
  const { t } = useTranslation('dashboard');
  const { setTextFilter, textFilter, textFilterLoading } = useTagCloud();

  return (
    <TextField
      data-test-id={TAG_CLOUD_SEARCH_TEST_ID}
      placeholder={t('TagCloud.TextFilter')}
      sx={styles.tagCloudSearch}
      onChange={(e) => setTextFilter(e.target.value)}
      value={textFilter}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {textFilterLoading ? (
              <CircularProgress
                size="1.5rem"
                data-test-id={TAG_CLOUD_TEXT_FILTER_LOADING_ICON_TEST_ID}
              />
            ) : (
              <SearchRounded
                data-test-id={TAG_CLOUD_TEXT_FILTER_SEARCH_ICON_TEST_ID}
              />
            )}
          </InputAdornment>
        ),
      }}
    />
  );
};

export default TagCloudSearch;
